import { default as SiteHeaderMobile } from './SiteHeaderMobile';
import SiteHeaderContainer from '../SiteHeader.container';
export default SiteHeaderContainer(SiteHeaderMobile);
//# sourceMappingURL=index.js.map